import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Onboarding } from 'app/shared/models/onboarding.model';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-edit',
  templateUrl: './add-edit.component.html',
  styleUrls: ['./add-edit.component.scss']
})
export class AddEditComponent implements OnInit {

  basicForm : FormGroup
  basicForm2 : FormGroup
  basicForm3 : FormGroup
  basicFormSubmitted :boolean = false
  basicFormSubmitted2 :boolean = false
  basicFormSubmitted3 :boolean = false
  activeTab='Step 1'
  onboarding_model:any = new Onboarding;
  user_id:any
  imgUrl:any;
  isEdit: boolean =false;
  fileData: File
  imageBaseUrl = environment.apiUrls.course_imageUrl
  formData = new FormData();
  currentUrl :any
  row_id:any
  constructor(private ref: ChangeDetectorRef,private formBuilder:FormBuilder,
              private apiService: ApiService,public toastr: ToastrService,
              private activateRoute: ActivatedRoute,private route: Router
              ) {
                this.currentUrl=this.activateRoute.snapshot.routeConfig.path
                this.activateRoute.paramMap.subscribe(params => { 
                  this.row_id = params.get('id'); 
              }); 
  }

  ngOnInit() {
    this.basicForm = this.formBuilder.group({
      about: ['',Validators.required],
    });
    this.basicForm2 = this.formBuilder.group({
      resume: ['',Validators.required],
      linkedIn: ['',Validators.required],
      isInterested : [false,Validators.required],
    });
    this.basicForm3 = this.formBuilder.group({
      notes: ['',],
      admin_notes: ['',],
    });
    if(this.row_id && this.currentUrl ==='add-edit/:id'){
      this.isEdit = true
      this.getOnboardingById(this.row_id)
    }
  }
  ngDoCheck(){
    this.ref.detectChanges();
  }

  get bf() {
    return this.basicForm.controls;
  }
  get bf2() {
    return this.basicForm2.controls;
  }
  get bf3() {
    return this.basicForm3.controls;
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.ref.detectChanges();
    }, 100);

  }
  setActiveTab(tab) {
    this.activeTab = tab;
  }
  onBasicFormSubmit() {
    this.basicFormSubmitted = true;
    if (this.basicForm.invalid) {
      return;
    }
    this.activeTab='Step 2'
  }
  onBasicFormSubmit2() {
    this.basicFormSubmitted2 = true;
    if (this.basicForm2.invalid) {
      return;
    }
    this.activeTab='Step 3'
  }
  onBasicFormSubmit3() {
    this.basicFormSubmitted3 = true;
    if (this.basicForm3.invalid) {
      return;
    }
    this.activeTab='Step 1'
  }
  submit(){
    const body = {
      about: this.basicForm.value.about,
      linkedIn: this.basicForm2.value.linkedIn,
      resume: this.basicForm2.value.resume,
      notes: this.basicForm3.value.notes,
      admin_notes: this.basicForm3.value.admin_notes,
      status: 'pending',
      student_id: this.user_id,
      is_interested: this.onboarding_model.is_interested
    };
  
    if(!this.isEdit){
      this.apiService.addOnboarding(body).subscribe((res: any) => {
        if(res?.statusCode === 200){
          this.toastr.success("Onboarding Added Successfully!");
          this.route.navigate(['/onboarding-reports/list'])
        }
        else {
          this.toastr.error(res.error);
        }
      });
    }
  
    if(this.isEdit && this.onboarding_model._id){
      this.apiService.updateOnboarding(this.onboarding_model._id, body).subscribe((res: any) => {
        if(res?.statusCode === 200){
          this.toastr.success("Onboarding Updated Successfully!");
          this.route.navigate(['/onboarding-reports/list'])
        }
        else {
          this.toastr.error(res.error);
        }
      });
    }
  }
  
 
  getOnboardingById(id){
    this.apiService.getOnboardingById(id).subscribe((res:any)=>{
      if(res?.statusCode === 200 ){
        this.onboarding_model = res?.data
        this.fileData = res?.data?.photo
      }
      
    })
  }
  
}